import { PayloadAction } from '@reduxjs/toolkit';
import { UserId } from 'features/users/types';
import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* disallowEditWhiteboardSaga(action: PayloadAction<UserId>) {
  yield call(SignalingSocket.send, {
    event: 'disallowEditWhiteboard',
    data: {
      id: action.payload,
    },
  });
}
